import { useQuery } from "@tanstack/react-query";

import { Discount } from "@modules/discounts/types";
import { ListDiscountsQueryFilters } from "./types";
import { listDiscountsService } from "./service";

export const listDiscountsQueryKey = (filters?: ListDiscountsQueryFilters) => [
  "discounts",
  "list",
  filters,
];

export function useListDiscountsQuery(filters?: ListDiscountsQueryFilters) {

  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  return useQuery<Discount[]>({
    queryKey: listDiscountsQueryKey(queryFilters),
    queryFn: () => listDiscountsService(filters),
  });
}
